module.exports = __webpack_public_path__ + "img/zwischenzeiten2.6db7bb49.jpg";